export const prefilledPollMock = {
    question: 'Type your question here',
    options: [
        { text: 'Type your first option here' },
        { text: 'Type your second option here' },
    ],
    openDays: 7,
};
//# sourceMappingURL=prefilled-poll-mock.js.map